<template>
  <div>
    <CCard>
      <CCardHeader>
        <h3 style="margin-top: 8px;">{{ $i18n.t("ofertas.nuevo") }}</h3>
      </CCardHeader>
      <CCardBody>
        <CRow form class="form-group">
          <CCol>
            <CSelect
              label="Tipo de concurso"
              :options="typeOptions"
              @change="handleType"
              horizontal
            ></CSelect>
          </CCol>
        </CRow>
        <CRow form class="form-group">
          <CCol sm="12">
            <!--<CInputFile :label="$i18n.t('ofertas.labels.importExcel')" horizontal />-->
            <CInputFile
              label="Importar excel"
              @change="handleExcelFile"
              horizontal
              multiple
              accept=".xls, .xlsx"
            />
          </CCol>
        </CRow>
        <CRow form class="form-group">
          <CCol>
            <CButton color="info" @click="readExcelFileList"
              >Cargar datos del excel</CButton
            >
          </CCol>
        </CRow>
        <CCollapse :show="registrosOferta.length > 0" :duration="400">
          <CRow v-for="(oferta, index) in registrosOferta" :key="index">
            <CCol>
              <CCard>
                <CCardHeader>
                  <CCol>
                    <CCardTitle
                      style="
                        display: inline-block;
                        margin-top: 13px;
                        margin-bottom: 0px;
                      "
                      ><b>Número de expediente: </b
                      >{{ oferta.numeroExpediente }}</CCardTitle
                    >
                    <CDropdown
                      v-if="!oferta.guardado"
                      toggler-text="Acciones"
                      style="
                        float: right;
                        display: inline-block;
                        margin-right: 10px;
                      "
                      class="m-2"
                      color="info"
                    >
                      <CDropdownItem @click="guardarOferta(oferta)"
                        >Guardar oferta</CDropdownItem
                      >
                      <CDropdownItem @click="eliminarItem(oferta)"
                        >Eliminar</CDropdownItem
                      >
                    </CDropdown>
                    <CButton
                    v-if="oferta.guardado"
                      style="
                        float: right;
                        display: inline-block;
                        margin-right: 10px;
                        margin-top: 8px;
                        margin-bottom: 8px;
                      "
                      color="success"
                      disabled
                      >Oferta guardada</CButton
                    >
                    <CButton
                      style="
                        float: right;
                        display: inline-block;
                        margin-right: 10px;
                        margin-top: 8px;
                        margin-bottom: 8px;
                      "
                      color="secondary"
                      @click="oferta.visible = !oferta.visible"
                      >{{
                        oferta.visible ? "Ocultar detalles" : "Ver detalles"
                      }}</CButton
                    >
                  </CCol>
                </CCardHeader>
                <CCollapse :show="oferta.visible" :duration="400">
                  <CDataTable
                    :id="'tabla' + index"
                    hover
                    sort
                    striped
                    :items="oferta.registros"
                    :fields="oferta.camposTabla"
                    :items-per-page="10"
                    sorter
                    pagination
                  >
                    <template #status="{ item }">
                      <td>
                        <CBadge :color="getBadge(item.status)">{{
                          item.status
                        }}</CBadge>
                      </td>
                    </template>

                    <template #nombreLicitador="{ item }">
                      <td>
                        {{ item['NOMBRE DEL LICITADOR'] }}
                      </td>
                    </template>
                    <template #dnicif="{ item }">
                      <td>
                        {{ item['DNI / CIF'] }}
                      </td>
                    </template>

                    <template #numeroConductoresSolvenciaTecnica="{ item }">
                      <td>
                        {{ item['Nº DE CONDUCTORES PARA TODOS LOS LOTES OFERTADOS (RELLENAR SOLO PRIMERA CELDA)'] }}
                      </td>
                    </template>
                    <template #numeroVehiculosSolvenciaTecnica="{ item }">
                      <td>
                        {{ item['Nº DE VEHICULOS PARA TODOS LOS LOTES OFERTADOS (RELLENAR SOLO PRIMERA CELDA)'] }}
                      </td>
                    </template>

                    <template #precioDiaSinIVA="{ item }">
                      <td>
                        {{ item['PRECIO DIA OFERTADO'] }} €
                      </td>
                    </template>
                  </CDataTable>
                </CCollapse>
              </CCard></CCol
            >
          </CRow>
        </CCollapse>
      </CCardBody>
    </CCard>

    <CModal
      :title="'Oferta: ' + ofertaSeleccionada.numeroExpediente"
      :show.sync="successModal"
      size="sm"
      centered
    >

      <div v-html="mensajeEvento">{{ mensajeEvento }}</div>

      <template #footer>
        <CButton
          @click="successModal = false"
          color="info"
          >Aceptar</CButton
        >
      </template>
    </CModal>

    <CModal
      :title="'Oferta: ' + ofertaSeleccionada.numeroExpediente"
      :show.sync="errorModal"
      size="lg"
      centered
    >
      <div v-html="mensajeError.label">{{ mensajeError.label }}</div>
      <br><br>
      <ul>
        <li v-for="error in mensajeError.errores" :key="error" v-html="error"> {{ error }} </li>
      </ul>

      <template #footer>
        <CButton
          @click="errorModal = false"
          color="danger"
          >Aceptar</CButton
        >
      </template>
    </CModal>
  </div>
</template>

<style scoped>
</style>

<script>
import Cookies from "js-cookie";
import VueExcelXlsx from "vue-excel-xlsx";
import CustomExport from "../../utils/CustomExport";
import { crearOfertaMasDeNueve, crearOfertaMenosDeNueve } from '../../requests/ofertas'
import XLSX from "xlsx";
import Vue from "vue";

Vue.use(VueExcelXlsx);

export default {
  name: "NuevaOferta",
  components: {
    CustomExport,
  },
  created() {},
  mounted() {},
  data() {
    return {
      typeOptions: [
        "Vehículos de MAS de 9 plazas",
        "Vehículos de MENOS de 10 plazas",
      ],
      selectedType: 0,
      numeroExpediente: "",
      successModal: false,
      mensajeEvento: "",
      errorModal: false,
      mensajeError: "",
      ofertaSeleccionada: {},
      registrosOferta: [],
      excelFiles: undefined,
    };
  },
  methods: {
    handleType(event) {
      console.log(event.target.value);
      this.selectedType = this.typeOptions.indexOf(event.target.value);
      this.registrosOferta = [];
      this.numeroExpediente = "";
    },
    handleExcelFile(event) {
      console.log(event);
      this.excelFiles = event;
    },
    readExcelFileList() {
      this.excelFiles.forEach((file) => {
        console.log("LEYENDO EXCEL");
        this.readExcelFile(file);
      });
    },
    saveSuccess(oferta) {
      this.successModal = true;
      this.mensajeEvento = "Se ha registrado la oferta correctamente"
      oferta.visible = false;
      oferta.guardado = true; //si se guarda se valida para desactivar el boton de acciones
    },
    descargarExcel(tablaJson) {
      exportToExcel(tablaJson);
    },
    eliminarItem(oferta){
      this.registrosOferta.splice(this.registrosOferta.indexOf(oferta),1);
    },
    guardarOferta(oferta) {
      this.ofertaSeleccionada = oferta;

      //se convierten los campos de la oferta a los necesarios para la request

      //datos del licitador y solvencia tecnica
      let nombreLicitador = oferta.registros[0]["NOMBRE DEL LICITADOR"];
      let dniCif = oferta.registros[0]["DNI / CIF"] + "";

      const claveVehiculos = Object.keys(oferta.registros[0]).find(key => key.includes("DE VEHICULOS PARA TODOS LOS LOTES OFERTADOS"));
      const claveConductores = Object.keys(oferta.registros[0]).find(key => key.includes("DE CONDUCTORES PARA TODOS LOS LOTES OFERTADOS"));

      let numVehiculosOfertados = oferta.registros[0][claveVehiculos];
      let numeroConductoresOfertados = oferta.registros[0][claveConductores];

      let ofertaRequest = {
          "licitadores.nombre": nombreLicitador,
          "licitadores.dnicif": dniCif,
          "solvenciatecnica.numeroVehiculosOfertados": numVehiculosOfertados,
          "solvenciatecnica.numeroConductoresOfertados": numeroConductoresOfertados,
          listadolotes: [],
      };

      //se convierten a los campos de la request los datos del excel
      oferta.registros.forEach((loteRaw) => {
        // Normalizar todas las claves y valores string del objeto lote:
        // algunos Excel incluyen \n y espacios extra en los nombres de columna
        const lote = Object.fromEntries(
          Object.entries(loteRaw).map(([k, v]) => [
            k.replace(/\s+/g, ' ').trim(),
            typeof v === 'string' ? v.replace(/\s+/g, ' ').trim() : v
          ])
        );

        const claveAccesibilidad = Object.keys(lote).find(key =>
          key.includes("ACCESIBILIDAD") && key.includes("(ANCLAJES Y PLATAFORMAS)")
        );

        const claveCumpleUNE = Object.keys(lote).find(key =>
          key.includes("Si su vehículo está adaptado:") && (key.includes("¿Cumple Norma UNE 26.494 y/ó tiene acreditación oficial de alguna administración pública?") || key.includes("¿Tiene la acreditación oficial de alguna administración pública?"))
        );

        const claveAntiguedad = Object.keys(lote).find(key => key.includes("ANTIGUEDAD VEHICULO"));
        const clavePlazas = Object.keys(lote).find(key => key.includes("PLAZAS TOTALES VEHICULO TITULAR"));

        const clavePrecio = Object.keys(lote).find(key =>
          key.includes("PRECIO DIA OFERTADO") && !key.includes("SIN IVA") && !key.includes("CON IVA")
        ) || Object.keys(lote).find(key => key.includes("PRECIO DIA OFERTADO (SIN IVA)"));
        const precioDia = lote[clavePrecio];
        const ivaColumna = Object.keys(lote).find(key => key === "IVA DIARIO");
        const ivaDiario = ivaColumna ? lote[ivaColumna] : 0;
        const claveConIVA = Object.keys(lote).find(key => key.includes("PRECIO DIA OFERTADO (CON IVA)"));
        const precioConIVA = claveConIVA ? lote[claveConIVA] : precioDia;

        let nuevoLote = {
          "expedientes.nombre":
            oferta.numeroExpediente + " " + lote["SUB EXPEDIENTE"],

          "lotes.numero": lote["LOTE"],

          "lotesofertados.ordenPreferencia":
            this.selectedType == 0 ? lote["ORDEN PREFERENCIA ADJUDICACION"] : lote["ORDEN PREFERENCIA ADJUDICACIÓN"],

          "lotesofertados.precioDiaSinIVA": precioDia,

          "lotesofertados.plazasTotales": clavePlazas ? lote[clavePlazas] : null,

          "antiguedad.descripcionAntiguedad": lote[claveAntiguedad],

          "licitadores.estabilidadLaboral": lote["ESTABILIDAD LABORAL"],

          "niveles_emision.descripcionEmision": lote["NIVELES EMISION GASES DE VEHICULO"],

          "lotesofertados.accesibilidad": lote[claveAccesibilidad],
          "lotesofertados.cumpleUNE": lote[claveCumpleUNE],
          "continuidad.descripcionContinuidad": lote["COMPROMISO DE GARANTIA DE LA CONTINUIDAD DEL SERVICIO"],
          
          /*
          "lotesofertados.vehiculoDisponible": lote[`MEDIOS DISPONIBLES DESDE LA PRESENTACIÓN DE LA OFERTA.\r\na) Vehículo`],

          "distancia_centro_trabajo.descripcion": lote[`MEDIOS DISPONIBLES DESDE LA PRESENTACIÓN DE LA OFERTA.\r\nb) Centro de Trabajo`],

          "distancia_taller_cochera.descripcion": lote[`MEDIOS DISPONIBLES DESDE LA PRESENTACIÓN DE LA OFERTA.\r\nc) Taller o Cochera`],*/
        };

        
        
        ofertaRequest.listadolotes.push(nuevoLote);
      });
      
      if(this.selectedType == 0){
        crearOfertaMasDeNueve(ofertaRequest).then(res => {
          this.mensajeError = {
            label: "",
            errores: [],
          }
          console.log(res.data)
          res.data.listadolotes.forEach((lote, index) => {
            if(lote.errores)
              lote.errores.forEach(error => {
                this.mensajeError.errores.push("<b>Fila " + (index + 1) + ":</b> " + error);
              })
          })
          if(res.data.resultadoGlobal !== "OK" || this.mensajeError.errores.length >= 1){
            this.mensajeError.label = "Se han encontrado los siguientes errores"
            if(this.mensajeError.errores.length === 0){
              this.mensajeError.errores.push("No se ha podido guardar la oferta. Revisa los datos e inténtalo de nuevo.");
            }
            this.errorModal = true;
          }else{
            this.saveSuccess(oferta);
          }
          
        }).catch(error => {
          console.log(error)
          this.successModal = true;
          this.mensajeEvento = "No se ha podido registrar la oferta. <br><br> Causa: <b>"+ error.response.data.error +"</b>" 
        });
      }else {
        crearOfertaMenosDeNueve(ofertaRequest).then(res => {
          this.mensajeError = {
            label: "",
            errores: [],
          }
          console.log(res.data)
          res.data.listadolotes.forEach((lote, index) => {
            if(lote.errores)
              lote.errores.forEach(error => {
                this.mensajeError.errores.push("<b>Fila " + (index + 1) + ":</b> " + error);
              })
          })
          if(res.data.resultadoGlobal !== "OK" || this.mensajeError.errores.length >= 1){
            this.mensajeError.label = "Se han encontrado los siguientes errores"
            if(this.mensajeError.errores.length === 0){
              this.mensajeError.errores.push("No se ha podido guardar la oferta. Revisa los datos e inténtalo de nuevo.");
            }
            this.errorModal = true;
          }else{
            this.saveSuccess(oferta);
          }
          
        }).catch(error => {
          console.log(error)
          this.successModal = true;
          this.mensajeEvento = "No se ha podido registrar la oferta. <br><br> Causa: <b>"+ error.response.data.error +"</b>" 
        });
      }
      
    },
    readExcelFile(file) {
   
      let reader = new FileReader();
      reader.onload = (e) => {
        let data = e.target.result;
        let registros = XLSX.read(data, {
          type: "binary",
        });

        let numeroExpediente;
        let lotes = [];
        let camposTabla = [];

        //se recoge solo el primer sheet del excel
        registros.SheetNames.forEach((sheetName, index) => {
          if (index > 0) return;
          let XL_row_object = XLSX.utils.sheet_to_json(
            registros.Sheets[sheetName],
            { range: this.selectedType == 0 ? 6 : 5 }
          );

          numeroExpediente = registros.Sheets[sheetName]["F2"].v; //recoge el numero de expediente del excel en la celda F2

          lotes = []; //lista de lotes de la oferta

          camposTabla = [];

          //recorre todos los nombres de la primera fila para crear los campos de la tabla
          Object.keys(XL_row_object[0]).forEach((keyVal) => { 
            let keyField = keyVal; //label que muestra la tabla
            
            //cambio la key de la tabla para identificar la columna y poder modificar manualmente lo que se muestra en esa columna
            //en este caso es porque solo se rellena la primera fila y para quitar el texto entre parentesis en el nombre de la columna
            if(keyField == "Nº DE VEHICULOS PARA TODOS LOS LOTES OFERTADOS (RELLENAR SOLO PRIMERA CELDA)"){
              keyVal = "numeroVehiculosSolvenciaTecnica";
              keyField = "Nº DE VEHICULOS PARA TODOS LOS LOTES OFERTADOS";
            }

            if(keyField == "Nº DE CONDUCTORES PARA TODOS LOS LOTES OFERTADOS (RELLENAR SOLO PRIMERA CELDA)"){
              keyVal = "numeroConductoresSolvenciaTecnica";
              keyField = "Nº DE CONDUCTORES PARA TODOS LOS LOTES OFERTADOS";
            }

            //Aqui lo mismo con el nombre del licitador y su dni
            if(keyField == "NOMBRE DEL LICITADOR"){
              keyVal = "nombreLicitador";
            }
            if(keyField == "DNI / CIF"){
              keyVal = "dnicif";
            }

            //Aqui lo mismo para identificar las columnas del dinero y mostrar el caracter de euros
            if(keyField == "PRECIO DIA OFERTADO" || keyField == "PRECIO DIA OFERTADO (SIN IVA)"){
              keyVal = "precioDiaSinIVA";
            }

            camposTabla.push({
              key: keyVal,
              field: keyField,
              label: keyField,
            });
          });

          //parsear los valores monetarios
          
          XL_row_object.forEach((registro, index) => {
            if (registro["SUB EXPEDIENTE"]) {
              /*registro["PRECIO DIA OFERTADO (SIN IVA)"] =
                registro["PRECIO DIA OFERTADO (SIN IVA)"].toFixed(2) + " €";
              registro["PRECIO DIA OFERTADO (CON IVA)"] =
                registro["PRECIO DIA OFERTADO (CON IVA)"].toFixed(2) + " €";
              registro["IVA DIARIO"] = registro["IVA DIARIO"].toFixed(2) + " €";*/
              lotes.push(registro);
            }
          });
        });

        this.registrosOferta.push({
          numeroExpediente: numeroExpediente,
          registros: lotes,
          camposTabla: camposTabla,
          visible: false,
        });
        this.$forceUpdate();
      };
      reader.readAsBinaryString(file);
    },
  },
  beforeDestroy() {},
};
</script>
